var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlash = function SvgIconFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 1.333 1 9.333h6l-.667 5.334 6.667-8H7l.667-5.334Z",
    fill: "#FFA66B",
    stroke: "#FFA66B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconFlash;